export const createEngine = function (canvas: HTMLCanvasElement, scaleFactor: number) {

    let _scaleFactor: number = scaleFactor;
    let engine = new BABYLON.Engine(canvas, true);
    window.addEventListener("resize", function (e) {
        if (engine) {
            engine.resize();
        }
    });
    window.addEventListener("orientationchange", function (e) {
        if (engine) {
            engine.resize();
        }
    });

    return engine;
}

export const createEnvironment = function (scene: BABYLON.Scene) {
    var hdrTexture = BABYLON.CubeTexture.CreateFromPrefilteredData("/static/environment/studio.env", scene, null, true);
    scene.environmentIntensity = 0.7;
    scene.environmentTexture = hdrTexture;
}

export const createScene = function (engine: BABYLON.Engine) {

    let scene = new BABYLON.Scene(engine); 
    scene.imageProcessingConfiguration.contrast = 1.8;
    scene.imageProcessingConfiguration.exposure = 1.0;
    scene.imageProcessingConfiguration.toneMappingEnabled = true;
    scene.clearColor = BABYLON.Color4.FromHexString("#FFFFFF");
    return scene;
}

export const createLight = function (name: string, scene: BABYLON.Scene, position: BABYLON.Vector3, direction: BABYLON.Vector3, intensity: number, shadowMinZ: number, shadowMaxZ: number) {

    let light = new BABYLON.DirectionalLight(name, direction, scene);
    light.intensity = intensity;
    light.autoCalcShadowZBounds = true;
    light.shadowEnabled = true;
   // light.radius = 1000;
    light.position = position;
    light.shadowMinZ = shadowMinZ;
    light.shadowMaxZ = shadowMaxZ;

    return light;
}

export const createRenderTargetCamera = function (scene: BABYLON.Scene) {

    let renderTargetCamera = createCamera("renderTarget",scene);  
    return renderTargetCamera;

}

export const createMainCamera = function (scene: BABYLON.Scene) {

    let mainCamera = createCamera("main", scene);  
    return mainCamera;

}

export const createCamera = function (name: string, scene: BABYLON.Scene) {

    let camera = new BABYLON.ArcRotateCamera(
        name,
        Math.PI,// Math.PI / 2,
        Math.PI,// Math.PI / 2.5,
        15,
        new BABYLON.Vector3(0, 0, 0),
        scene
    );

    camera.angularSensibilityX = 1000;
    camera.angularSensibilityY = 1000;   
    camera.panningSensibility = 1000;
    camera.panningInertia = 0;
    camera.panningAxis = new BABYLON.Vector3(1, 0, 1);
    camera.inertia = 0;
    camera.useNaturalPinchZoom = true;
    camera.wheelDeltaPercentage = 0.05;
    camera.fov = 0.6;  
   // camera.upperBetaLimit = Math.PI / 2;
  //  camera.lowerBetaLimit = 0;
    camera.lowerRadiusLimit = 1;
    camera.upperRadiusLimit = 30;
    camera.fovMode = BABYLON.Camera.FOVMODE_HORIZONTAL_FIXED;
    camera.minZ = 1;
    camera.maxZ = 1000;

    return camera;

}

export const createGround = function (light: BABYLON.ShadowLight, scene: BABYLON.Scene) {

    var ground = BABYLON.MeshBuilder.CreateGround("ground", { width: 1000, height: 1000 }, scene);
  
    ground.material = new BABYLON.ShadowOnlyMaterial('shadowOnly', scene);
    (ground.material as BABYLON.ShadowOnlyMaterial).activeLight = light;
    ground.material.alpha = 0.15;
    ground.receiveShadows = true;
    ground.isPickable = false;

    return ground;

}
export const createShadowgenerator = function (light: BABYLON.ShadowLight, darkness: number, penumbra: number) {

    var shadowGenerator = new BABYLON.ShadowGenerator(1024, light);
    shadowGenerator.setDarkness(darkness);   
    shadowGenerator.usePoissonSampling = true;
    //shadowGenerator.useContactHardeningShadow = true;
   // shadowGenerator.filteringQuality = BABYLON.ShadowGenerator.QUALITY_LOW;    
    shadowGenerator.bias = 0.015;
    shadowGenerator.normalBias = -0.015;
   // shadowGenerator.contactHardeningLightSizeUVRatio = penumbra;    

    return shadowGenerator;

}